import { COMMON_PLOT_CONFIG, THEME } from "../../../../../constants";
import Plot from "react-plotly.js";
import PropTypes from "prop-types";
import { useMemo } from "react";

// Helper function: Approximation for inverse error function (erfinv)
function erfinv(x) {
  let a = 0.147; // Magic constant
  let ln = Math.log(1 - x * x);
  let s = 2 / (Math.PI * a) + ln / 2;
  let result = Math.sign(x) * Math.sqrt(Math.sqrt(s * s - ln / a) - s);
  return result;
}

const layout = {
  autosize: true,
  showlegend: false,
  margin: {
    r: 20,
    t: 20,
    l: 40,
    b: 40,
  },

  plot_bgcolor: "transparent",
  paper_bgcolor: "white",
  colorway: THEME.baseColors,
};

const config = {
  toImageButtonOptions: {
    filename: "",
  },
  ...COMMON_PLOT_CONFIG,
};

export const QQPlot = ({ residuals }) => {
  const displayData = useMemo(() => {
    const observed = residuals.toSorted((a, b) => a - b);
    const theoretical = observed.map(
      (_, i) => Math.sqrt(2) * erfinv(2 * ((i - 0.5) / observed.length) - 1)
    );

    return [
      {
        x: theoretical,
        y: observed,
        type: "scatter",
        mode: "markers",
      },
    ];
  }, [residuals]);

  return (
    <Plot useResizeHandler data={displayData} layout={layout} config={config} />
  );
};

QQPlot.propTypes = {
  residuals: PropTypes.arrayOf(PropTypes.number).isRequired,
};
